var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[(_vm.isLoading)?_c('LoadingListPlaceholder',[_vm._t("mock")],2):(_vm.isEmpty)?_c('EmptyListPlaceholder',{attrs:{"height":_vm.emptyHeight,"message":_vm.emptyMessage,"message-size":_vm.emptyMessageSize,"icon":_vm.emptyIcon,"icon-size":_vm.emptyIconSize}}):_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }